import { Component, EventEmitter, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-header-galleries',
  templateUrl: './header-galleries.component.html',
  styleUrl: './header-galleries.component.scss',
  standalone: true,
    imports: [CommonModule, TranslateModule, FormsModule]
})
export class HeaderGalleriesComponent {
    @Output() onSearch = new EventEmitter<string>();

    onChange(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.onSearch.emit(value);
    }
}
